/*
Phobject checklist
getObject()
this.group
this.phobject
setupPhysics

*/
import * as THREE from 'three'

export default class Phyobject {

    constructor(move){
        this.phobjects= [];
        this.move = move;
    }

    getFocusObjects(){
        let objs = this.phobjects.filter((f)=>{return f.canFocus()});
        return objs;
    }

    canFocus(){
        return false;
    }

    setupPhysics(){
        this.phyobject = this.world.add( options );
    }    

    addPhobject(pho, pos, rot){
        pho.world = this.world; // pass down the world
        this.phobjects.push(pho);        
        pho.setupPhysics(pos);
        let obj = pho.getObject()
        if(rot!=undefined)
            obj.rotation.y = rot.y;
        //obj.rotation.x = 1;
        this.group.add(obj);
    }

    simulate(delta){   
        //if(this.phyobject.move===true)
        if(this.move)
        {
            this.group.position.copy( this.phobject.getPosition());
            this.group.quaternion.copy( this.phobject.getQuaternion());
        }

        this.phobjects.forEach((pho)=>{pho.simulate(delta);});
    }
}